"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_INDICATOR_OPTIONS = exports.DEFAULT_INDICATOR_RADIUS = exports.DEFAULT_INDICATOR_STROKE_COLOR = exports.DEFAULT_COLOR_SCALE = exports.DEFAULT_LABEL_FORMAT = exports.DEFAULT_BULLET_HEIGHT = exports.DEFAULT_BULLET_OPACITY = exports.DEFAULT_TEXT_COLOR = void 0;
const lodash_1 = __importDefault(require("lodash"));
const colors_1 = require("../../utilities/colors");
exports.DEFAULT_TEXT_COLOR = '#4D4D4D';
exports.DEFAULT_BULLET_OPACITY = 0.3;
exports.DEFAULT_BULLET_HEIGHT = 10;
exports.DEFAULT_LABEL_FORMAT = 'default';
exports.DEFAULT_COLOR_SCALE = lodash_1.default.fill(lodash_1.default.range(6), colors_1.NAMED_COLORS.gray);
// options for the indicator
exports.DEFAULT_INDICATOR_STROKE_COLOR = '#FFFFFF';
exports.DEFAULT_INDICATOR_RADIUS = 8;
exports.DEFAULT_INDICATOR_OPTIONS = {
  strokeWidth: 2,
  strokeColor: exports.DEFAULT_INDICATOR_STROKE_COLOR,
  onMouseOver: () => {},
  onClick: () => {},
  onMouseOut: () => {}
};